import { ResponseDto } from '@diritto/common/base/response.dto';
import { EpisodeViewFileResponseDto } from '@diritto/common/episode/dtos/episode-view.response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class EpisodeViewApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getEpisodeFile(episodeId: number, options?: AxiosRequestConfig): Promise<EpisodeViewFileResponseDto> {
    const res = await this.http.get<EpisodeViewFileResponseDto>(`${this.url}/episodes/view/${episodeId}/file`, options);
    return res.data;
  }

  async readEpisode(episodeId: number) {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/episodes/view/${episodeId}/read`);
    return res.data;
  }
}
